export enum ErrorReference {
    pflichtfeldText = '#LABEL ist ein Pflichtfeld.',
    pflichtfeldRadio = 'Bitte treffen Sie eine Auswahl.',
    pflichtfeldCheckbox = 'Das Kontrollkästchen ist ein Pflichtfeld.',
    datumUngueltig = 'Bitte geben Sie das Datum im korrekten Format ein: TT.MM.JJJJ zum Beispiel: #DATE_TODAY',
    datumVergangenheit = 'Das Datum darf nicht in der Vergangenheit liegen.',
    uhrzeitVergangenheit = 'Die Uhrzeit darf nicht in der Vergangenheit liegen.',
    datumUngueltigJahrMonat = 'Bitte geben Sie das Datum im korrekten Format ein: MM.JJJJ zum Beispiel: #DATE_TODAY',
    geburtsdatumInZukunft = 'Geburtsdatum darf nicht in der Zukunft liegen.',
    betragFormat = 'Falsches Format xxx,xx',
    betragNegativeFormat = 'Falsches Format xxx,xx oder -xxx,xx',
    percent = 'Bitte geben Sie eine Zahl zwischen 1 und 100 ein',
    timeFormat = 'Falsches Format XX:XX',
    emailFormat = 'Ihre E-Mail Adresse weist kein gültiges Format auf. Bitte korrigieren Sie Ihre Eingabe.',
    pflichtfeldUpload = 'Bitte laden Sie mindestens eine Datei hoch.',
}
